import React from "react";
import Icon from "@mdi/react";
import {
  mdiCashMultiple,
  mdiCheckBold,
  mdiCreditCardPlus,
  mdiLoading,
  mdiClose,
  mdiAlertCircle,
} from "@mdi/js";

export { default as MoreOptionsIcon } from "./MoreOptionsIcon";
export { default as BidirectionalMoneyIcon } from "./BidirectionalMoney";
export { default as MethodClassIcon } from "./MethodClassIcon";

const defaults = {
  size: 1,
  color: "currentColor",
};

const makeIcon =
  (svg, testid, makeProps = {}) =>
  (laterProps) => {
    // pluck off non-DOM attributes
    const { _css2, _css3, _css4, ...finalLaterProps } = laterProps;
    return (
      <Icon path={svg} {...defaults} data-testid={testid} {...makeProps} {...finalLaterProps} />
    );
  };

export const CheckIcon = makeIcon(mdiCheckBold, "check-icon");
export const CloseIcon = makeIcon(mdiClose, "close-icon");
export const CreditCardIcon = makeIcon(mdiCreditCardPlus, "credit-card-outline-icon");
export const WalletIcon = makeIcon(mdiCashMultiple, "wallet-icon", {
  size: "40px",
});
export const LoadingIcon = makeIcon(mdiLoading, "loading-icon", {
  spin: 1,
  size: "1rem",
});
export const AlertIcon = makeIcon(mdiAlertCircle, "alert-icon");
